export default function (context, val) {
    context.commit('set_agreement', {
        code: val.code,
    });
    if (!context.state.form.ContragentID && context.getters.options_contragents.length) {
        context.dispatch('change_ContragentID_select',context.getters.options_contragents[0].value);
    }
    context.dispatch('agreement_comment', val.code);
    // if (context.getters.requests_currency(agreement).value !== context.state.form.CurrencyId) {
    //     if (context.state.form.ContragentType === 3 && context.getters.requests_currency(agreement).AGCurrency !== context.state.form.CurrencyId) {
    //         context.dispatch('agreement_getCourse', val.code);
    //     }
    // }
}